<template>
	<el-select
		:id="id == null ? prop : id"
		v-model="localModelValue"
		:value-key="valueKey"
		@change="(value) => emitEvent('change', value)"
		:disabled="disabled"
		:readonly="readonly"
		:placeholder="generalMethods.translate(placeholder)"
		:size="size"
		:teleported="false"
		:class="elClasses"
		:clearable="clearable"
		:multiple="multiple"
		filterable
	>
		<el-option
			v-for="(option, index) in options"
			:key="index"
			:label="
				optionFunction
					? optionLabelKey(option)
					: optionEnglishArabicName
						? generalMethods.getValueByCurrentLanguage(
								option[(optionLabelKey == '' ? '' : optionLabelKey + '_') + 'english_name'],
								option[(optionLabelKey == '' ? '' : optionLabelKey + '_') + 'arabic_name']
							)
						: generalMethods.translate(option[optionLabelKey == '' ? 'name' : optionLabelKey])
			"
			:value="option"
		/>
	</el-select>
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";

import * as generalMethods from "@/core/mixins/general_methods";
import * as customValidation from "@/core/mixins/custom_validation";

export default defineComponent({
	name: "c-input",
	props: {
		id: { type: String, default: null },
		label: { type: String, default: null },
		prop: { type: String, default: null },
		valueKey: { type: String, default: "id" },
		options: { default: [] },
		optionEnglishArabicName: { type: Boolean, default: false },
		optionLabelKey: { type: String, default: "" },
		optionFunction: { default: null },
		modelValue: {},
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		placeholder: { type: String, default: "select" },
		hideLabel: { type: Boolean, default: false },
		size: { type: String, default: "default" },
		elClasses: { type: String, default: "w-100" },
		clearable: { type: Boolean, default: false },
		multiple: { type: Boolean, default: false },
	},
	setup(props, { emit }) {
		const localModelValue = computed({
			get() {
				return props.modelValue;
			},
			set(newValue) {
				emit("update:modelValue", newValue);
			},
		});

		const emitEvent = (event, value) => {
			emit(event, value);
		};

		return {
			generalMethods,
			customValidation,

			localModelValue,

			emitEvent,
		};
	},
});
</script>
